import { render, staticRenderFns } from "./DoctorKyc.vue?vue&type=template&id=75fd8bc3&scoped=true"
import script from "./DoctorKyc.vue?vue&type=script&lang=js"
export * from "./DoctorKyc.vue?vue&type=script&lang=js"
import style0 from "./DoctorKyc.vue?vue&type=style&index=0&id=75fd8bc3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75fd8bc3",
  null
  
)

export default component.exports